'use strict';

import AxiosService from '../AxiosService';

const ADDRESS_ENDPOINT = "/api/v1/addresses";

export default class PhoneUpdateService {
    constructor() {
        this.service = new AxiosService();
    }

    update(id, phoneUpdate) {
        return this.service.put(ADDRESS_ENDPOINT + "/" + id + "/phone", phoneUpdate);
    }

}